<div class="flex flex-col items-start reviews px-4! py-2!">
    <span class="flex w-full items-center">
        <div class="w-12 h-12 flex justify-center items-center">
            <p-avatar [label]="message().data.sender?.firstInitial ?? '' + message().data.sender?.lastInitial"
                class="text-white bg-slate-500 text-lg" size="large" shape="circle"></p-avatar>
        </div>
        <div class="flex flex-col ml-2 w-full">
            <div class="flex justify-between items-start gap-2">

                <div class="mt-1">
                    <span class="mr-1">
                        {{message().data.content?.primaryText}}
                    </span>

                    @if (message().data.content?.tertiaryText) {
                    <a class="text-primary font-bold cursor-pointer"
                        [routerLink]="'/t/' + authService.userPrincipalComputedSignal()?.currentTenantExternalId + message().data.content?.tertiaryUrl"
                        showDelay]="500" pTooltip="Navigate to Release" tooltipPosition="top" target="_blank"
                        rel="noopener noreferrer">
                        {{message().data.content?.tertiaryText}}
                    </a>
                    }
                </div>

            </div>

            <div class="flex justify-between items-center my-1">

                <div>
                    @if (message().data.content?.secondaryText) {
                    <a class="text-primary font-bold cursor-pointer"
                        [routerLink]="'/t/' + authService.userPrincipalComputedSignal()?.currentTenantExternalId + message().data.content?.secondaryUrl"
                        [showDelay]="500" pTooltip="Navigate to Release Feed" tooltipPosition="top" target="_blank"
                        rel="noopener noreferrer">
                        <i class="fa-solid fa-bars-staggered"></i>
                        {{message().data.content?.secondaryText}}
                    </a>
                    }
                </div>

            </div>

        </div>
    </span>
</div>